// extracted by mini-css-extract-plugin
module.exports = {"scrollContainer":"Ticker_scrollContainer__GblkY","scrollText":"Ticker_scrollText__3hw1L","myAnimation":"Ticker_myAnimation__3hnTp"};